<div class="material-datatables">
  <table [id]="table_id" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
    <thead>
      <tr>

        <th class="disabled-sorting"><b>PP#</b></th>
        <th class="disabled-sorting"><b>Client</b></th>
        <th class="disabled-sorting"><b>Last Update</b></th>
        <th class="disabled-sorting"><b>Status</b></th>
        <th class="disabled-sorting"><b>Date</b></th>
        <th class="disabled-sorting"><b>Rep</b></th>
        <th class="disabled-sorting text-right"><b>Actions</b></th>

      </tr>
    </thead>
    <tbody>
      <tr style="cursor: pointer;" *ngFor="let item of data">

        <td><strong style="font-size: 2rem" matTooltip="{{item.account}}" matTooltipPosition="above">{{item.pp}}</strong></td>
        <td>{{item.vendorTable.name}} {{item.vendorTable.surname}}</td>
        <td>{{item.updatedAt | date: 'MM-dd-yyyy'}}</td>
        <td>{{item.status}}</td>
        <!--<td>{{item.createdAt | date: 'MM-dd-yyyy'}}</td>-->
        <td>{{item.dateProposal | date: 'MM-dd-yyyy'}}</td>
        <td>{{item.rep.name}} {{item.rep.surname}}</td>
        <td style="text-align: right">

          <a class="btn btn-link btn-info btn-just-icon">
            <i class="material-icons emitir" id="show-{{item.id}}">remove_red_eye</i>
          </a>

          <a class="btn btn-link btn-dark btn-just-icon">
            <i class="material-icons emitir" id="print-{{item.id}}">local_printshop</i>
          </a>

          <a class="btn btn-link btn-danger btn-just-icon">
            <i class="material-icons emitir" id="delete-{{item.id}}">close</i>
          </a>

        </td>
      </tr>
    </tbody>

  </table>
</div>